import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';

// Lazy load components
const RestaurantMenuView = lazy(() => import('../Pages/RestaurantMenuView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined;

function RestaurantMenuRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/restaurant/menu"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <RestaurantMenuView history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
        </Switch>
    );
};

export default RestaurantMenuRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
